module.exports = __webpack_public_path__ + "static/romanianViolin-5a3b5ebe4a20629fab7fea6a88223c97.mp3";